"use client";

import { createContext, useContext, ReactNode } from "react";

export type BlogTheme = "dark";
export type ResolvedTheme = "dark";

interface BlogThemeContextType {
  theme: BlogTheme;
  resolvedTheme: ResolvedTheme;
  setTheme: (theme: BlogTheme) => void;
}

const BlogThemeContext = createContext<BlogThemeContextType | undefined>(
  undefined
);

// Blog is always dark — no light mode toggle
export function BlogThemeProvider({ children }: { children: ReactNode }) {
  return (
    <BlogThemeContext.Provider
      value={{ theme: "dark", resolvedTheme: "dark", setTheme: () => {} }}
    >
      {children}
    </BlogThemeContext.Provider>
  );
}

export function useBlogTheme() {
  const context = useContext(BlogThemeContext);
  if (context === undefined) {
    throw new Error("useBlogTheme must be used within a BlogThemeProvider");
  }
  return context;
}
